<template>
  <v-container fluid fill-height id="login-page">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-card-text>
            <div class="text-center mb-4">
              <img src="../assets/logo.png" alt="uCamp.it"/>
            </div>

            <div v-if="tokenValid">
              <form @submit.prevent="submitNewPassword">
                <v-text-field
                    v-model="newPassword"
                    label="Nuova password"
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    prepend-icon="mdi-lock"
                    required
                ></v-text-field>

                <v-text-field
                    v-model="confirmPassword"
                    label="Conferma password"
                    :type="showPassword ? 'text' : 'password'"
                    prepend-icon="mdi-lock-check"
                    required
                ></v-text-field>

                <ul class="mb-3" style="font-size: 0.85rem; color: #999;">
                  <li>Minimo 8 caratteri</li>
                  <li>Almeno una lettera maiuscola</li>
                  <li>Almeno una lettera minuscola</li>
                  <li>Almeno un numero</li>
                  <li>Almeno un carattere speciale (!@#$%^&*)</li>
                </ul>

                <v-btn color="primary" large type="submit" block>
                  Reimposta password
                </v-btn>
              </form>
            </div>

            <div v-else class="text-center">
              <v-progress-circular v-if="loading" indeterminate color="primary" />
              <v-alert v-else type="error" dense>
                Token non valido o scaduto. Verrai reindirizzato al login...
              </v-alert>
            </div>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import {mapActions} from "vuex";

export default {
  name: 'RecoveryPassword',
  data: () => ({
    user_id: null,
    token: '',
    tokenValid: false,
    newPassword: '',
    confirmPassword: '',
    showPassword: false,
    loading: true,
  }),
  methods: {
    ...mapActions({
      checkToken: 'user/checkToken',
      sendResetPassword: 'user/sendResetPassword',
    }),
    async validateToken() {
      this.loading = true;

      try {

        const result = await this.checkToken({
          token: this.token
        });

        if(result.success && result._id){
          this.user_id = result._id;
          this.tokenValid = true
        }else {
          this.tokenValid = false
        }

      } catch (e) {
        this.tokenValid = false;
      }

      this.loading = false;

      if (!this.tokenValid) {
        setTimeout(() => this.$router.push('/login'), 3000);
      }
    },

    isPasswordStrong(password) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^+=(){}[\]\\|<>,.:;"'~`_-])[A-Za-z\d@$!%*?&#^+=(){}[\]\\|<>,.:;"'~`_-]{8,}$/;
      return regex.test(password);
    },

    async submitNewPassword() {
      if (this.newPassword !== this.confirmPassword) {
        this.$store.commit('settings/setNotification', {
          active: true,
          color: 'error',
          text: 'Le password non corrispondono.'
        });
        return;
      }

      if (!this.isPasswordStrong(this.newPassword)) {
        this.$store.commit('settings/setNotification', {
          active: true,
          color: 'error',
          text: 'La password non rispetta i requisiti di sicurezza.'
        });
        return;
      }

      try {

        const result = await this.sendResetPassword({
          _id: this.user_id,
          password: this.newPassword
        });


        if (result.success) {
          this.$store.commit('settings/setNotification', {
            active: true,
            color: 'success',
            text: 'Password reimpostata con successo. Effettua l’accesso tramite il login.'
          });
          this.$router.push('/login');
        } else {
          this.$store.commit('settings/setNotification', {
            active: true,
            color: 'error',
            text: data.message || 'Errore nella reimpostazione della password.'
          });
        }
      } catch (e) {
        this.$store.commit('settings/setNotification', {
          active: true,
          color: 'error',
          text: 'Errore durante la richiesta.'
        });
      }
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    if (!this.token) {
      this.$router.push('/login');
    } else {
      this.validateToken();
    }
  }
}
</script>



<style scoped>
#login-page {
  background-color: #222b54;
}
</style>